import { PersistentNotification } from '../../lib/interfaces/persistentNotification';

const setNotification = (
  stateNotification: any,
  newNotification: PersistentNotification
): void => {
  stateNotification.type = newNotification.type;
  stateNotification.title = newNotification.title;
  stateNotification.text = newNotification.text;
  stateNotification.link.text = newNotification.link?.text;
  stateNotification.link.url = newNotification.link?.url;
  stateNotification.link.external = newNotification.link?.external;
  stateNotification.route = newNotification.route;
};

const initialState = () => ({
  queuedNotification: {
    type: undefined,
    title: undefined,
    text: undefined,
    link: {
      text: undefined,
      url: undefined,
      external: undefined
    },
    route: undefined
  }
});

export const state = initialState();

export const mutations = {
  setQueuedNotification(
    state: any,
    notification: PersistentNotification
  ): void {
    setNotification(state.queuedNotification, notification);
  },

  resetQueuedNotification(): void {
    setNotification(
      state.queuedNotification,
      initialState().queuedNotification
    );
  }
};
